<template>
  <div  class="app-layout">
    <TopNav />

    <div class="main-content">
      <SideMenu :module="currentModule" />
      <div class="module-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import TopNav from '@/components/layout/TopNav.vue'
import SideMenu from '@/components/layout/SideMenu.vue'
import { ref, computed, reactive, provide, inject, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const currentModule = computed(() => route.meta.module)

const isMobile = inject('isMobile')
const sideMenuCollapsed = ref(isMobile.value)
provide('sideMenuState', {
  collapsed: sideMenuCollapsed,
  toggle: () => {
    sideMenuCollapsed.value = !sideMenuCollapsed.value
  },
  expand: () => {
    sideMenuCollapsed.value = false
  },
  collapse: () => {
    sideMenuCollapsed.value = true
  }
})

</script>

<style scoped>
  .app-layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    overflow-x: auto;

    /* Make sure layout fits visible area on iOS */
    min-height: 100dvh;
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .main-content {
    display: flex;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
  }

  .module-content {
    flex: 1;
    overflow-x: auto;
    box-sizing: border-box;
    overflow-y: hidden;
  }

</style>